<template>
  <div class="product-bd tb" v-if="funcView.product_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.product_add && isAdmin">
          <el-button type="primary" icon="el-icon-plus" @click="jump('/product/add')">{{ funcView.product_add }}</el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item v-if="funcView.expt_product_info" style="float: right; margin-right: 0">
          <el-button class="table-set" @click="exportTable"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 切换项 -->
        <el-form-item style="float: right" v-if="funcView.product_lisToBlock">
          <el-button style="vertical-align: top" class="table-set" @click="showCart = !showCart">
            <i style="font-size: 12px" class="icon icon-menu" v-if="!showCart"></i>
            <i style="font-size: 12px" class="icon icon-liebiao" v-else></i>
          </el-button>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_product.cpSNcpxhcpmc')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <template v-if="isAdmin">
          <el-form-item :label="$t('dms_product.ISTzhan_dian')">
            <custom-select
              v-model="formSearch.websiteCode"
              filterable
              url="websiteSelectList"
              :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
              :props="{ label: 'websiteName', value: 'websiteCode' }"
              width="100%"
            ></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_product.guo_jia')">
            <custom-select v-model="formSearch.countryCode" filterable url="factoryDeliveryPlaceSelectList" :props="{ label: 'placeName', value: 'placeCode' }" width="100%"></custom-select>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item :label="$t('dms_product.ERPbian_ma')">
            <el-input v-model="formSearch.productErpCode" @input="onPageChange({ page: 1 })" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_product.ERPming_cheng')">
            <el-input v-model="formSearch.productErpName" @input="onPageChange({ page: 1 })" :clearable="true"></el-input>
          </el-form-item>
        </template>
      </el-form>
    </switch-container>
    <div class="table-bd" v-if="!showCart">
      <custom-table
        height="100%"
        :data="productList"
        :column="tableColumn"
        :index="true"
        :slots="['productSn', 'cleanWheelParam', 'protocolCode', 'supportFunc']"
        @filter="filterChange"
        @sort="sortChange"
      >
        <template v-slot:supportFunc="scope">
          {{ getSportFunc(scope.row) }}
        </template>
        <template v-slot:protocolCode="scope">
          <el-popover @after-enter="getProtocolList(scope.row)" @after-leave="hidePopover(scope.row)" width="240" placement="bottom" trigger="hover">
            <support-protocol-detail v-if="scope.row.popover" :data="scope.row.protocolList" tableCode="product_protocol_detail"></support-protocol-detail>
            <!-- <el-table
              style="width: 300px;"
              :data="scope.row.details"
            >
              <el-table-column
                label="序号"
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                prop="protocolClass"
                label="协议类别"
              ></el-table-column>
              <el-table-column
                prop="protocolCode"
                label="协议编号"
              ></el-table-column>
            </el-table> -->
            <span style="text-align: center; padding: 0 10px" class="table-link" slot="reference">{{ $t('Common.com_detail') }}</span>
            <!-- <el-button slot="reference" type="text">查看设备详情</el-button> -->
          </el-popover>
        </template>
        <template v-slot:productSn="scope">
          <span style="color: #2aafff; text-decoration: underline; cursor: pointer" v-if="funcView.product_preview" @click="openProductDetail(scope.row.productId)">{{ scope.row.productSn }}</span>
          <span v-else>{{ scope.row.productSn }}</span>
        </template>
        <template v-slot:cleanWheelParam="scope">
          <el-popover trigger="hover" placement="bottom">
            <!-- <p>
              {{ $t('label_cleaning_area }}：{{
                scope.row[scope.column.property].totalArea
              }}
              {{ $t('label_unit_square_meter }}
            </p> -->
            <p>
              {{ $t('dms_product.lun_zi_zhi_jing') }}：{{ scope.row[scope.column.property].wheelDiameter }}
              {{ $t('dms_product.mi') }}
            </p>
            <p>
              {{ $t('dms_product.lun_zi_zhou_chang') }}：{{ scope.row[scope.column.property].wheelPerimeter }}
              {{ $t('dms_product.mi') }}
            </p>
            <p>
              {{ $t('dms_product.shua_zi_kuan_du') }}：{{ scope.row[scope.column.property].brushWidth }}
              {{ $t('dms_product.mi') }}
            </p>
            <p>
              {{ $t('dms_product.zxqjmj') }}（{{ $t('dms_product.lun_zi_zhou_chang') }}*{{ $t('dms_product.shua_zi_kuan_du') }}）： {{ scope.row[scope.column.property].minCleanArea
              }}{{ $t('dms_product.ping_fang_mi') }}
            </p>
            <p>
              {{ $t('dms_product.jzqjmj') + '(㎡/' + $t('dms_product.tian') + ')' }}：{{ scope.row[scope.column.property].basicArea }}
            </p>
            <p>
              {{ $t('dms_product.jzqjsc') + '(min/' + $t('dms_product.tian') + ')' }}：{{ scope.row[scope.column.property].basicTime }}
            </p>
              <p>
              {{ $t('dms_product.dcsjrl') }}：{{ scope.row[scope.column.property].designCapacity }}
            </p>
            <!-- <p>
              {{ $t('label_max_working_hours }}：{{
                scope.row[scope.column.property].maxCircleNumPerHour
              }}
              {{ $t('label_unit_hour }}
            </p>
            <p>
              {{ $t('label_daily_max_working_hours }}：{{
                scope.row[scope.column.property].maxWorkHourPerDay
              }}
              {{ $t('label_unit_hour }}
            </p>
            <p>
              {{ $t('label_daily_max_charge_hours }}：{{
                scope.row[scope.column.property].maxChargingHourPerDay
              }}
              {{ $t('label_unit_hour }}
            </p> -->
            <!-- <div
              slot="reference"
              class="name-wrapper"
            >
              <span style="color: #2AAFFF; cursor: pointer;">{{
                $t('page_content_device_param
              }}</span>
            </div> -->
            <span style="text-align: center; padding: 0 10px" class="table-link" slot="reference">{{ $t('Common.com_detail') }}</span>
          </el-popover>
        </template>
        <el-table-column :label="$t('Common.com_handle')" min-width="120" fixed="right" v-if="!!tableColumn.length && isAdmin">
          <template slot-scope="scope">
            <el-button
              v-if="funcView.product_edit && isAdmin"
              type="text"
              size="mini"
              @click="
                jump('/product/edit', {
                  productId: scope.row.productId,
                  productCode: scope.row.productCode,
                  productSn: scope.row.productSn,
                })
              "
            >
              {{ funcView.product_edit }}
            </el-button>
            <el-button v-if="funcView.product_delete && isAdmin" type="text" size="mini" @click="deleteProduct(scope.row)">{{ funcView.product_delete }}</el-button>
            <!-- <el-button
              v-if="funcView.product_force_delete"
              type="text"
              size="mini"
              @click="forceDel(scope.row)"
            >{{ funcView.product_force_delete }}</el-button> -->
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="card-bd" v-if="showCart">
      <ul>
        <li v-for="(item, index) in productList" :key="index">
          <i v-if="isAdmin" @click="deleteProduct(item)" class="btn-del icon icon-shanchu"></i>
          <i v-if="funcView.product_edit && isAdmin" :style="{ right: !isAdmin ? '17px' : '' }" @click="jump('/product/edit', { productId: item.productId })" class="btn-edit icon icon-bianji"></i>
          <div class="img-box">
            <img v-if="getAttachUrl(item)" :src="getAttachUrl(item)" alt />
          </div>
          <div class="product-code">{{ item.productName }}</div>
          <div class="product-sn">{{ item.productCode }}</div>
          <div class="status">{{ propertyMapObj[item.productState] }}</div>
        </li>
      </ul>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 查看产品型号 -->
    <product-info v-if="showProductInfo" :productId="productId" :visible.sync="showProductInfo"></product-info>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import supportProtocolDetail from '@/pages/dms/components/support_protocol_detail';
import productInfo from './children/product_info.vue';

export default {
  name: 'product',
  mixins: [resetFormSearchMixins],
  components: { productInfo, supportProtocolDetail },
  data() {
    return {
      tableCode: '',
      dialogVisible: false,
      dialogModel: {},
      productId: '',
      productTotal: 0,

      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        productErpCode: '',
        productErpName: '',
        websiteCode: '',
        countryCode: '',
      },
      showCart: false,
      productList: [],
      totalRows: null,
      isLoading: false,
      propertyMapObj: {},
      showProductInfo: false,
      link: null,
    };
  },
  activated: function () {
    this.getProductList();
  },
  computed: {
    bizType() {
      return this.$store.state.userInfo.bizType;
    },
    isAdmin() {
      return this.$store.state.userInfo.bizType === 'PF';
    },
  },
  watch: {
    bizType: {
      immediate: true,
      handler(val) {
        if (val) {
          const isAdmin = this.$store.state.userInfo.bizType === 'PF';
          this.tableCode = isAdmin ? 'product_manage' : 'product_factory_manage';
          this.getTableColumn();
        }
      },
    },
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getDictionary('dms_product_state', (data) => {
      this.propertyMapObj = this.$transformDicValue(data.dms_product_state || []);
    });
  },
  methods: {
    // 获取产品支持功能
    getSportFunc(row) {
      const { supportFunc } = row;
      if (supportFunc) {
        const arr = supportFunc.split(',');
        const ret = arr.map((str) => this.getDicValue('iot_product_support_func', str));
        return ret.join(',');
      }
      return '';
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.ProductExport, {}).then(() => {});
    },
    // 获取产品列表
    getProductList: function () {
      this.$getJSON(apis.ProductPage, this.formSearch).then((res) => {
        const list = res.data.list;
        list.forEach((item) => {
          item.cleanWheelParam = item.cleanWheelParam ? JSON.parse(item.cleanWheelParam) : {};
        });
        this.formatAttachList(list, 'productCodeId', 'dms.product.icon').then((result) => {
          this.productList = result;
        });
        this.totalRows = res.data.total;
      });
    },
    // 查看产品详情
    openProductDetail: function (productId) {
      this.productId = productId;
      this.showProductInfo = true;
    },
    // 删除产品
    deleteProduct: function (data) {
      this.$showConfirm(this.$t('dms_product.nqdyscxzdcpm')).then(() => {
        this.$postJSON(`${apis.ProductDel}/${data.productId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.getProductList();
        });
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getProductList();
    },
    // 获取产品协议列表
    getProtocolList: function (row) {
      this.$getJSON(apis.productProtocolList, {
        productSn: row.productSn,
      }).then((res) => {
        const list = res.data;
        this.$set(row, 'protocolList', list);
        this.$set(row, 'popover', true);
      });
    },
    hidePopover: function (row) {
      this.$set(row, 'popover', false);
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.product-bd {
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 220px;
    display: flex;
    .g2-p1 {
      width: 400px;
      height: 200px;
      & > div {
        top: 15px;
      }
    }
    .g2-p2 {
      width: 460px;
      height: 200px;
      .g2-legend {
        height: 120px !important;
        width: 800px !important;
        max-width: 800px !important;
      }
      .g2-legend-list {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100%;
      }
      .g2-legend-list-item {
        width: 120px;
      }
    }
  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 217px;
        height: 288px;
        border-radius: 4px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 16px;
        margin-bottom: 16px;
        position: relative;
        overflow: hidden;
        .btn-del {
          position: absolute;
          color: #0d9ae0;
          font-size: 14px;
          right: 17px;
          bottom: 13px;
          display: block;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #0d9ae0;
          font-size: 14px;
          right: 47px;
          bottom: 13px;
          display: block;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 57px;
          font-size: 14px;
          background-color: #0d9ae0;
          border-bottom-left-radius: 28px;
          text-align: right;
          padding-right: 10px;
        }
        .img-box {
          $r: 160px;
          width: $r;
          height: $r;
          position: relative;
          margin-top: 32px;
          margin-left: auto;
          margin-right: auto;
          img {
            position: absolute;
            max-width: 100%;
            max-height: 100%;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
        .product-code {
          margin-top: 20px;
          color: #0d9ae0;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          line-height: 22px;
        }
        .product-sn {
          font-size: 14px;
          color: #495057;
          line-height: 20px;
          position: absolute;
          left: 16px;
          bottom: 11px;
        }
      }
    }
  }
}
</style>
